<script type="text/javascript">
    // 定义一些公共的属性和方法
    //const remoteIp = 'http://1.116.52.226:80';
    //const remoteIp = 'http://127.0.0.1:80';
    const remoteIp = '';
    
    //从右到左滚动
    function srcollpic(x, y, z) {
        var speed = 30
        var demo2 = document.getElementById(x);
        var demo1 = document.getElementById(y);
        var demo = document.getElementById(z);
        demo2.innerHTML = demo1.innerHTML;

        function Marquee() {
            if (demo2.offsetWidth - demo.scrollLeft <= 0)
                demo.scrollLeft -= demo1.offsetWidth;
            else {
                demo.scrollLeft++;
            }
        }
        var MyMar = setInterval(Marquee, speed)
        demo.onmouseover = function () {
            clearInterval(MyMar)
        }
        demo.onmouseout = function () {
            MyMar = setInterval(Marquee, speed)
        }
    }
    function isPhone() {
        var mobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return mobile != null
    }
    
    function sortByTop(arr) {
        for(var i = 0; i <arr.length; i++)
        {
            if(arr[i].top == '1')
            {
                arr.slice(i,1);
                arr.unshift(arr[i]);
                break;
            }
        }
        return arr;
    }
    // 暴露出这些属性和方法
    export default {
        remoteIp,
        srcollpic,
        sortByTop,
        isPhone
    }
</script>